import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import { idKeyExtractor, padding } from '@src/configuration/constants';
import { Journey, Post, PrimeBook, Rank, TourSummery, User } from '@src/types';

export const ItemsContainer = styled.View`
  padding: 0 ${padding}px;
`;

export const CarouselContainer = styled.View`
  ${Platform.OS === 'web' ? 'min-height: 220px' : ''};
  margin-top: 10px;
`;

export const JourneysList = styled(
  FlatList as new () => FlatList<Journey>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  initialNumToRender: 6,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
  },
}))``;

export const ToursList = styled(
  FlatList as new () => FlatList<TourSummery>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  initialNumToRender: 6,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingVertical: padding,
    minHeight: 194,
  },
}))``;

export const PostsList = styled(FlatList as new () => FlatList<Post>).attrs(
  () => ({
    horizontal: true,
    removeClippedSubviews: true,
    initialNumToRender: 3,
    keyExtractor: idKeyExtractor,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingHorizontal: padding,
      paddingVertical: padding / 3,
    },
  })
)``;

export const UsersList = styled(FlatList as new () => FlatList<User>).attrs(
  () => ({
    horizontal: true,
    removeClippedSubviews: true,
    initialNumToRender: 6,
    keyExtractor: idKeyExtractor,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingHorizontal: padding,
    },
  })
)``;

export const HerosList = styled(FlatList as new () => FlatList<Rank>).attrs(
  () => ({
    horizontal: true,
    removeClippedSubviews: true,
    initialNumToRender: 6,
    keyExtractor: ({ user }) => user.id,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingHorizontal: padding,
      paddingVertical: padding / 4,
    },
  })
)``;

export const PrimeBooksList = styled(
  FlatList as new () => FlatList<PrimeBook>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  initialNumToRender: 6,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingVertical: padding / 4,
  },
}))``;
